<template>
  <div>
    <!--[GCDM-234858] Select-All-Checkbox-Implementation-of-a-Select-All-Checkbox-for-Korea-->
    <div class="select-all-container" :class="brandClass()" v-if="$c('show_select_all_checkboxes') && orderedPolicyDocuments.length>0">
      <OneCheckbox
        :brandClass="brandClass()" 
        v-model="selectAll" 
        :paramName="'select_all'"
        :id="'select_all'"
        @input="(e)=>{selectUnselectAll(e)}"
        :required="false"
        :labelledBy="'select-all-label'"
      >
        <template v-slot:labelcontent>
          <span class="select-all-label" >
            <span :class="brandClass()">
              <span id="select-all-label">{{$t('select_all')}}</span>
            </span>
          </span>
        </template>
      </OneCheckbox>
    </div>
    <form action="">
      <OnePolicyConsents
        v-for="(policyConfig, index) in orderedPolicyDocuments"
        :ref="'policy-document-'+index"
        class="policypopup"
        :policyIndex="index"
        :policyConfig="policyConfig"
        :key="policyConfig.policy_document_name"
        @onClose="cancelPopup"
        :isProfileSection="false"
        :brandClass="brandClass()"
        :t="$t"
        :c="$c"
        @policyDowloaded="savePolicyObject($event)"
        @policyUpdated="policyUpdated($event)"
      ></OnePolicyConsents>
    </form>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import OneCheckbox from "../../gcdm-one-library/gcdm-one-checkbox/src/OneCheckbox";

export default {
  inject:['$c', '$t', 'brandClass'],
  name: "PolicyConsentsPopup",
  components: {
    OneCheckbox,
    OnePolicyConsents: defineAsyncComponent(() =>
      import('../../gcdm-one-library/gcdm-one-policy-consents/src/OnePolicyConsents')
    )
  },
  data: () => ({
    selectAll: false,
    policyConsentsToSend: {}
  }),
  emits:["onPolicyCreated","onPolicyUpdated"],
  props: ["policyDocuments","title","subtitle","content", "button_confirm_label", "button_cancel_label"],
  computed: {
    orderedPolicyDocuments() {
      return this.policyDocuments?.sort((a, b) => {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      }) ?? [];
    }
  },
  methods:{
    //[GCDM-234858] Select-All-Checkbox-Implementation-of-a-Select-All-Checkbox-for-Korea
    selectUnselectAll(e){
      for (let index = 0; index < this.orderedPolicyDocuments.length; index++) {
        let policyKey = this.orderedPolicyDocuments[index].policy_document_name;
        this.policyConsentsToSend[policyKey].consents.map((p)=>{p.consent = !this.selectAll ? 'ACCEPT' : 'REJECT'});
        this.policyConsentsToSend[policyKey].dirty=true;
        this.$refs['policy-document-'+index][0].selectAll(!this.selectAll);
      }
    },  

    savePolicyObject: function(policyInfo){
      this.policyConsentsToSend[policyInfo.policy_document_name] = policyInfo;
      this.$emit("onPolicyCreated", policyInfo);
      if(this.$c('show_select_all_checkboxes')) this.handleSelectAll();
    },
    policyUpdated: function(policyInfo){
      this.policyConsentsToSend[policyInfo.policy_document_name].consents.map((p)=>{if(p.usage_id==policyInfo.usageId)p.consent=policyInfo.accepted});
      this.policyConsentsToSend[policyInfo.policy_document_name].dirty=true;
      this.$emit("onPolicyUpdated", policyInfo);
      if(this.$c('show_select_all_checkboxes')) this.handleSelectAll();
    },
    handleSelectAll(){
      for(let policyDocument in this.policyConsentsToSend) {
        if(this.policyConsentsToSend[policyDocument]['consents'].find(c => c.consent != 'ACCEPT')){
          this.selectAll = false;
          break;
        }else{
          this.selectAll = true;
        }
      }
    },
    close(){
      this.$emit('onClose');
    },
    cancelPopup(){
      this.$emit('onPolicyUpdated');
    }
  }
};
</script>

<style lang="scss">
.select-all-label{
  font-size:16px;
  min-height: 24px;
  .__m{
    font-size: 18px;
  }
}
.select-all-container{
  display: flex;
  margin-bottom: 20px;
  .custom-field--valid{
    margin-top: 4px;
  }
}
.profile-wrapper{
  .content{
    .policypopup{
      .checkbox-container{
        margin-top: 0;
      }
    }
  }
}

</style>
